/* @flow */
import { loadGroupAvatars, fetchGroupAvatar } from 'actions/AvatarActions';
import Avatar from 'entities/Avatar';
import AvatarStore from 'stores/AvatarStore';
import { Container } from 'flux/utils';
import GroupAvatarPicker from './GroupAvatarPicker.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import * as React from 'react';
import errorLogger from 'utils/errorLogger';

import './styles/GroupAvatarSelector.scss';

const MIN_HIDDEN_AVATAR_ID = 9001;

type Props = {
  onSelect: Avatar => {},
  initialAvatar: ?Avatar,
};

type State = {
  avatar: Avatar,
};

class GroupAvatarSelector extends React.Component<Props, State> {
  static getStores() {
    return [AvatarStore];
  }

  static calculateState(prevState, props) {
    let avatar = null;

    if (prevState && prevState.avatar) {
      avatar = prevState.avatar;
    } else {
      if (props.initialAvatar) {
        avatar = AvatarStore.getGroupAvatars().get(props.initialAvatar.id);
        // HACK: In order to display hidden avatars for classes that have them selected
        if (!avatar && props.initialAvatar.id >= MIN_HIDDEN_AVATAR_ID) {
          avatar = props.initialAvatar;
        }
      } else {
        avatar = AvatarStore.getGroupAvatars().getRandomAvatar();
      }
    }

    return {
      avatar,
    };
  }

  componentDidMount() {
    if (!AvatarStore.areGroupAvatarsLoaded()) {
      loadGroupAvatars();
    }
  }

  onAvatarSelected = avatar => {
    this.setState({ avatar });
    this.props.onSelect(avatar);
  };

  getSelectedAvatar = () => {
    return this.state.avatar;
  };

  getSelectedAvatarId = () => {
    return this.state.avatar.id;
  };

  searchAvatarForName = name => {
    fetchGroupAvatar(name)
      .then(avatars => {
        const avatar = avatars.first();

        if (avatar) {
          this.setState({ avatar });
        }
      })
      .catch(errorLogger('GroupAvatarSelector fetchGroupAvatar failed'));
  };

  renderAvatar = () => {
    return <Image className="GroupAvatarSelector-Avatar" src={this.state.avatar.getUrl()} circle />;
  };

  renderPlaceholder = () => {
    return <div className="GroupAvatarSelector-Placeholder" />;
  };

  render() {
    const groupAvatarPickerModal = (
      <GroupAvatarPicker
        onSelect={this.onAvatarSelected}
        selectedAvatar={this.state.avatar ? this.state.avatar.id : null}
      />
    );

    return (
      <div className="GroupAvatarSelector">
        <ModalTrigger modal={groupAvatarPickerModal}>
          <div>
            {this.state.avatar ? this.renderAvatar() : this.renderPlaceholder()}

            <div className="GroupAvatarSelector-Subtext">
              <Link href="#">Edit icon</Link>
            </div>
          </div>
        </ModalTrigger>
      </div>
    );
  }
}

export default Container.create(GroupAvatarSelector, {
  withProps: true,
  pure: false,
});
